module.exports = __webpack_public_path__ + "static/img/aqzs15.0bd405e5.jpg";